import { React } from 'libs/react';
/**
 * @const LINK_PATTERN
 * @since 1.0.0
 * URLs, e-mail addresses and North American phone numbers. Phones need
 * separators so order or deal numbers are left alone. Trailing punctuation
 * stays out of URLs.
 */
const LINK_PATTERN = new RegExp([
    /((?:https?:\/\/|www\.)[^\s<]*[^\s<.,;:!?)\]'"])/.source,
    /([\w.+-]+@[\w-]+(?:\.[\w-]+)+)/.source,
    /((?:\+?1[\s.-])?\(?\d{3}\)?[\s.-]\d{3}[\s.-]\d{4})(?!\d)/.source
].join('|'), 'g');
/**
 * @function linkify
 * @since 1.0.0
 * Splits plain text into strings and anchors. Nothing is parsed as HTML, so
 * user content needs no sanitizing.
 */
export function linkify(text) {
    const nodes = [];
    let last = 0;
    let match;
    LINK_PATTERN.lastIndex = 0;
    while ((match = LINK_PATTERN.exec(text))) {
        const [value, url, email, phone] = match;
        if (match.index > last) {
            nodes.push(text.slice(last, match.index));
        }
        let href;
        if (url) {
            href = url.startsWith('www.') ? 'https://' + url : url;
        }
        else if (email) {
            href = 'mailto:' + email;
        }
        else {
            href = 'tel:' + phone.replace(/[^\d+]/g, '');
        }
        nodes.push(React.createElement("a", { key: match.index, href: href, target: url ? '_blank' : undefined, rel: url ? 'noopener noreferrer' : undefined, onClick: (e) => e.stopPropagation() }, value));
        last = match.index + value.length;
    }
    if (last < text.length) {
        nodes.push(text.slice(last));
    }
    return nodes;
}
